/*
 * @Author: Dong
 * @Date: 2022-04-16 17:04:27
 * @LastEditors: luting
 * @LastEditTime: 2022-08-18 15:49:24
 */
interface ConfigStateType {
  checked: boolean; // 是否开启
  config?: ConfigType; // 配置信息
}

interface ConfigType {
  filePath: string; // 文件储存路径
  startTime: string; // 开始自动备份时间
  intervalTimes: number; // 备份频率
  retainCount: number; // 保留份数
  nextRunTime: string; // 下次备份时间
  intervalUnit?: string; // 备份频率单位，不传默认为DAY(目前没有用到这个参数)
}

interface ModalStateType {
  visible: boolean; // 显隐弹框
  type?: string; // 弹框类型
  data?: any; // 弹框数据
  isFromSwitch?: boolean; // 是否为从Switch打开的弹窗
}

const configReducer = (state: ConfigStateType, action: { type: string; params?: any }) => {
  const { type, params } = action;

  switch (type) {
    // 开关自动备份
    case 'toggleChecked':
      return {
        ...state,
        checked: params.checked,
      };
    case 'setConfig':
      return {
        ...state,
        config: { ...params },
      };
    default:
      return { ...state };
  }
};

const modalReducer = (state: ModalStateType, action: { type: string; params?: any }) => {
  const { type, params } = action;

  switch (type) {
    // 显隐弹框
    case 'toggleVisible':
      return {
        ...state,
        visible: !state.visible,
        ...params,
      };

    case 'setData':
      return {
        ...state,
        ...params,
      };
    default:
      return { ...state };
  }
};

const initConfig: ConfigStateType = {
  checked: false,
};

const initModal: ModalStateType = {
  visible: false,
};

export { configReducer, initConfig, modalReducer, initModal };
